import { render } from "./Swp.vue?vue&type=template&id=440bd423"
import script from "./Swp.vue?vue&type=script&lang=js"
export * from "./Swp.vue?vue&type=script&lang=js"
script.render = render

export default script